module.exports = __webpack_public_path__ + "img/task_bg.583c41df.png";